import React, { Component } from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import Table from 'react-bootstrap/Table';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';

import CustomPagination from '../../CustomPagination';
import Link from '../../Link/Link';
import Loader from '../../../components/Common/Loader';

import messages from '../../../locale/messages';
import { deleteLocation } from '../../../actions/siteadmin/deleteLocation';
import { updateLocation } from '../../../actions/siteadmin/updateLocation';

import EditIcon from '../../../../public/Icons/edit.png';
import TrashIcon from '../../../../public/Icons/bin.svg';

import s from './ManageLocation.css';
import bt from '../../../components/commonStyle.css';
export class LocationList extends Component {
    static propTypes = {
        locationList: PropTypes.object,
    }

    constructor(props) {
        super(props)
        this.scrollableDivRef = React.createRef();
        this.state = {
            currentPage: 1,
        }
    }

    handleSearchClick = (searchList) => {
        const { locationList: { refetch } } = this.props
        let variables = {
            currentPage: 1,
            searchList: searchList
        }
        this.setState({ currentPage: 1 })
        refetch(variables)
    }

    handleSearchChange = (e) => {
        let self = this
        if (self.state.typingTimeout) {
            clearTimeout(self.state.typingTimeout)
        }
        self.setState({
            searchList: e.target.value,
            typing: false,
            typingTimeout: setTimeout(function () {
                self.handleSearchClick(self.state.searchList)
            }, 450)
        })
    }

    handleDelete = async (id, currentPage) => {
        const { locationList: { refetch, getLocationList }, deleteLocation } = this.props;
        let variables = {
            currentPage: currentPage > 1 && getLocationList?.LocationData?.length == 1 ? currentPage - 1 : currentPage
        }
        await deleteLocation(id, currentPage);
        this.setState({ currentPage: variables.currentPage });
        refetch(variables);
    }

    handleChange = async (e, id, locationName, description, coordinates) => {
        const { updateLocation, locationList: { refetch } } = this.props;
        this.setState({ currentPage: 1 });
        let variables = { currentPage: 1 };
        let isActive = e.target.value;
        await updateLocation(locationName, coordinates, id, description, isActive);
        refetch(variables);
    }

    paginationData = (currentPage) => {
        const { locationList: { refetch } } = this.props;
        let variables = { currentPage };
        this.setState({ currentPage });
        if (this.scrollableDivRef.current) {
            this.scrollableDivRef.current.scrollTop = 0;
        }
        refetch(variables);
    }

    render() {
        const { locationList, locationList: { getLocationList }, loading } = this.props;
        const { currentPage } = this.state;
        const { formatMessage } = this.props.intl;
        return (
            <div className={cx(s.widthInner, 'whiteDropdown', 'bgBlackTwo')}>
                <div className={bt.tableTopGrpContainer}>
                    <div className={s.searchInput}>
                        <FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(e) => this.handleSearchChange(e)} className={bt.formControlInput} />
                    </div>
                    <div className={cx(bt.padding2, bt.paddingTop2, s.displayInlineBlock)}>
                        <Link to={"/siteadmin/manage-location"} className={cx(bt.btnPrimary, 'btnPrimaryDark')} >{formatMessage(messages.addLocation)}</Link>
                    </div>
                </div>
                <div class="clearfix"></div>
                {
                    loading && <div>
                        <Loader type="circle" />
                    </div>
                }
                {!loading &&
                    <div className={cx(s.tableCss, 'tableCss', 'tableSticky', 'NewResponsiveTable', 'topScrollbarTable')} ref={this.scrollableDivRef}>
                        <Table className={cx("table", 'topScrollbarTableContent')}>
                            <thead>
                                <tr>
                                    <th scope="col"><FormattedMessage {...messages.id} /></th>
                                    <th scope="col"><FormattedMessage {...messages.location} /></th>
                                    <th scope="col"><FormattedMessage {...messages.description} /></th>
                                    <th scope="col"><FormattedMessage {...messages.status} /></th>
                                    <th scope="col"><FormattedMessage {...messages.action} /></th>
                                    <th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    locationList?.getLocationList?.LocationData && locationList?.getLocationList?.LocationData?.length > 0 && locationList?.getLocationList?.LocationData?.map((item, index) => {
                                        item.isActive = item.isActive == true ? 1 : 0;
                                        return (
                                            <tr key={index}>
                                                <td data-label={formatMessage(messages.id)}>{item.id}</td>
                                                <td data-label={formatMessage(messages.location)}>{item.locationName}</td>
                                                <td data-label={formatMessage(messages.description)}>{item.description}</td>
                                                <td data-label={formatMessage(messages.status)}>
                                                    <select name="isActive" onChange={(e) => this.handleChange(e, item.id, item.locationName, item.description, item.coordinates)} className={bt.selectInput} value={item.isActive}>
                                                        <option value={1}>{formatMessage(messages.active)}</option>
                                                        <option value={0}>{formatMessage(messages.inactive)}</option>
                                                    </select>
                                                </td>
                                                <td data-label={formatMessage(messages.action)}><Link to={'/siteadmin/edit-location/' + item.id} className={cx('editAlign', s.displayFlex)}><span className={'svgImg'}><img src={EditIcon} className={cx(s.editIcon, 'editIconRTL')} /></span>
                                                    <span className={s.vtrMiddle}>
                                                        <FormattedMessage {...messages.editAction} />
                                                    </span></Link></td>
                                                <td data-label={formatMessage(messages.deleteAction)} >

                                                    <Button onClick={() => this.handleDelete(item.id, currentPage)} className={cx(s.iconBtn, 'svgImg', 'btnPrimaryDeleteDark', "iconBtnRtl")}>
                                                        <img src={TrashIcon} className={cx(s.editIcon, 'editIconRTL')} />
                                                        <span className={s.vtrMiddle}>
                                                            <FormattedMessage {...messages.deleteAction} />
                                                        </span>
                                                    </Button>

                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                {
                                    locationList?.getLocationList?.LocationData && locationList?.getLocationList?.LocationData?.length == 0 && (
                                        <tr>
                                            <td colspan="12" className={s.noRecords}><FormattedMessage {...messages.noResult} /></td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                    </div>
                }
                {
                    locationList?.getLocationList?.LocationData && locationList?.getLocationList?.LocationData?.length > 0
                    && <div className={cx(bt.space5, bt.spaceTop5)}>
                        <CustomPagination
                            total={locationList?.getLocationList?.count}
                            currentPage={currentPage}
                            defaultCurrent={1}
                            defaultPageSize={10}
                            change={this.paginationData}
                            paginationLabel={locationList.getLocationList.count == 1 ? formatMessage(messages.locationName) : formatMessage(messages.locations)}
                        />
                    </div>
                }
            </div>
        )
    }
}
const mapState = (state) => ({
    loading: state?.intl?.loading
});
const mapDispatch = {
    deleteLocation,
    updateLocation
};
export default injectIntl(compose(
    withStyles(s, bt),
    connect(mapState, mapDispatch)
)(LocationList));

